import { ref } from 'vue';
import { Tab, Tabs, showImagePreview, Overlay, Col, Row, closeToast, showLoadingToast } from 'vant';
import { postue } from '../../api/utils/request.ts';
export default {
  setup() {
    const kid = ref('');
    const ImgCount = ref('');
    const VideoCount = ref('');
    const home_pics = ref([]);
    const home_videos = ref([]);
    const OriginalImgList = ref([]);
    const VideoC_Url = ref('');
    const show = ref(false);
    return {
      kid,
      ImgCount,
      VideoCount,
      home_pics,
      home_videos,
      OriginalImgList,
      VideoC_Url,
      show
    };
  },
  mounted() {
    console.info(this.$route.query);
    this.kid = this.$route.query.kid;
    var param1 = {
      ASTActId: this.$route.query.kid,
      Type: '1',
      ReqType: 'hyd'
    };
    showLoadingToast({
      message: '加載中...',
      forbidClick: true,
      duration: 0
    });
    postue('Auction/Common/GetASTResources', param1).then(res => {
      console.log(res);
      if (res.code == 1) {
        console.info(res);
        this.home_pics = res.data.ImgList, this.home_videos = res.data.VideoList, this.ImgCount = '設備照片(' + res.data.ImgCount + ')', this.VideoCount = '設備視頻(' + res.data.VideoCount + ')', this.OriginalImgList = res.data.OriginalImgList;
      }
      closeToast();
    });

    //     get('/apiue/Auction/Common/GetASTResources',{
    //         ASTActId:this.$route.query.id,
    //         Type:'1',
    //         ReqType:'hyd',
    //     }).then((res) => {
    //       if(res.success){
    //         console.info(res)
    //         this.home_pics=res.result.data.ImgList,
    //         this.home_videos=res.result.data.VideoList,
    //         this.ImgCount='設備照片('+res.result.data.ImgCount+')',
    //         this.VideoCount='設備視頻('+res.result.data.VideoCount+')',
    //         this.OriginalImgList=res.result.data.OriginalImgList

    //         // this.loading=false
    //       }
    //   })
  },

  methods: {
    ImagePrediv(url) {
      var index = this.OriginalImgList.findIndex(item => {
        return item == url;
      });
      showImagePreview({
        images: this.OriginalImgList,
        startPosition: index
      });
    },
    playvideo(url) {
      // console.log(url)
      // console.log(this.VideoC_Url)
      // this.show=true
      // this.VideoC_Url=url
      // console.log(this.VideoC_Url)
      window.open(url);
    },
    closeoverlay() {
      console.log('close');
      this.show = false, this.VideoC_Url = '';
      console.log(this.VideoC_Url);
    }
  }
};